import React, { FC, useEffect } from "react";
import { encryptData } from "../../../../utils/helper";
import { useNavigate } from "react-router";
import { AES_KEY } from "../../../../constants/app";

interface IRefundHeaderProps {}

const RefundHeader: FC<IRefundHeaderProps> = () => {

  const navigator = useNavigate();

  const openSeatSwap = ()=>{
    // const encrypt = encryptData(ticketDetails.userSessionId, AES_KEY);
    // navigator(
    //   `/${currentCinema.alias}/seat-swap/${encodeURIComponent(encrypt)}`
    // );
  }

  return (
    <div className="refund-wrapper">
      <div className="col-12 px-2">
        <div className="refund-header">
          Request Refund
        </div>
      </div>
    </div>
  );
};

export default RefundHeader;
